import React from 'react'
import './editor.scss'
import { StudioApp } from './StudioApp'

const HeadlessStudioPage: React.FC = () => {
  return <StudioApp generateOnReady />
}

export default HeadlessStudioPage
